var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7555 4.97638L3.76885 17.0767C3.64265 17.2952 3.5762 17.5431 3.57617 17.7954C3.57615 18.0478 3.64256 18.2957 3.76872 18.5142C3.89488 18.7327 4.07635 18.9142 4.29489 19.0404C4.51343 19.1666 4.76132 19.233 5.01366 19.2329H18.9858C19.2381 19.233 19.486 19.1666 19.7046 19.0404C19.9231 18.9142 20.1046 18.7327 20.2307 18.5142C20.3569 18.2957 20.4233 18.0478 20.4233 17.7954C20.4233 17.5431 20.3568 17.2952 20.2306 17.0767L13.2447 4.97638C13.1186 4.75791 12.9372 4.57649 12.7187 4.45035C12.5002 4.32422 12.2524 4.25781 12.0001 4.25781C11.7478 4.25781 11.5 4.32422 11.2815 4.45035C11.063 4.57649 10.8816 4.75791 10.7555 4.97638Z",
    fill: "#DC1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0904 8.70312H11.9081C11.4594 8.70312 11.0957 9.06687 11.0957 9.51556V13.3989C11.0957 13.8476 11.4594 14.2113 11.9081 14.2113H12.0904C12.5391 14.2113 12.9028 13.8476 12.9028 13.3989V9.51556C12.9028 9.06687 12.5391 8.70312 12.0904 8.70312Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 17.2915C12.4983 17.2915 12.9028 16.887 12.9028 16.3879C12.9028 15.8889 12.4983 15.4844 11.9993 15.4844C11.5002 15.4844 11.0957 15.8889 11.0957 16.3879C11.0957 16.887 11.5002 17.2915 11.9993 17.2915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.04aa0f0d78cd44c63db760f73d545b44.svg";
export { ForwardRef as ReactComponent };